<template>
    <div 
    class="form-group col-md-12">
        <form-label 
        v-if="row.name">
            {{$trans(row.name)}}
        </form-label>

        <div class="form-check"
        :key="option.value"
        v-for="option in options">

            <input 
            class="form-check-input" 
            type="checkbox"
            :name="row.key"
            :id="row.key+'-'+option.value" 
            v-model="value"
            @input="input"
            :value="option.value">

            <label 
            class="form-check-label" 
            :for="row.key+'-'+option.value">
                {{option.label}}
            </label>

        </div> <!-- /.form-check -->

        <form-errors :errors="row.key" />
        
    </div>
</template>

 
<script>

    import {mapState} from 'vuex'

    export default {

        data() {
            return {
                value: []
            }
        },

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        },

        computed: {
            options() {
                var options = this.$trans(this.row.value)

                return _.map(options, (label, value) => {
                    return {
                        label: label,
                        value: value
                    }
                })
            }
        },

        methods: {
            input() {
                setTimeout(() => {
                    this.$emit('input', this.value)
                }, 200)
            }
        }

    }
</script>